export default "__VITE_ASSET__CDP0CuW6__"